<template>

    <div class="card-body position-relative" @mouseover="displayActions = true" @mouseout="displayActions = false">
        <div v-for="field in table.fields" class="card-text">

            <div v-if="isPrimaryField(field)">
                <strong>
                    <router-link :to="detailsRoute(document['id'])">
                        {{field.name}}: {{fieldValue(field)}}
                    </router-link>
                </strong>
            </div>

            <field-renderer v-else :field="field" :document="document" :table="table" :render-text="false"></field-renderer>

        </div>

        <list-item-actions v-if="authorized" :table="table" :document="document" :parent-table="parentTable" :parent-document="parentDocument"
                           :class="displayActions ? 'd-flex' : 'd-none'"></list-item-actions>

    </div>
</template>

<script>
    import ModelService from "../../services/ModelService";
    import TableUtil from "../../utils/TableUtil";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import SelectView from "../../components/SelectView.vue";
    import CheckboxView from "../../components/CheckboxView.vue";
    import AttachmentViewer from "../controls/AttachmentViewer.vue";
    import DateRenderer from "../../components/DateRenderer.vue";
    import FieldUtil from "../../utils/FieldUtil";
    import NumberRenderer from "../renderers/NumberRenderer.vue";
    import ListItemActions from "../../components/ListItemActions.vue";
    import FieldRenderer from "../renderers/FieldRenderer.vue";

    export default {
        name: 'ListItem',
        components: {
            FieldRenderer,
            ListItemActions,
            NumberRenderer, DateRenderer, AttachmentViewer, CheckboxView, SelectView, ConfirmModal},
        props: ['table', 'document', 'parentDocument', 'parentTable'],
        data() {
            return {
                model: webase.model,
                service: new ModelService(),
                tableUtil: new TableUtil(),
                displayActions: false,
                permissionManager: webase.managers.permission
            }
        },
        computed: {
            authorized() {
                if (this.permissionManager.fullAccess()) {
                    return true
                }

                return this.permissionManager.isAuthorized(this.table, this.document, this.parentTable, this.parentDocument)
            },
            parentDocumentId() {
                return this.parentDocument && this.parentDocument['id'] ? this.parentDocument['id'] : null
            },
            parentTableId() {
                return this.parentTable && this.parentTable.id ? this.parentTable.id : null
            },
            isChildList() {
                return this.parentTable && this.parentDocument ? true : false
            }
        },
        mounted() {
        },
        methods: {
            fieldValue(field) {
                if (field.field_type === 'Collaborator') {
                    return this.document[field.index].name
                }

                return this.document[field.index]
            },
            isPrimaryField(field) {
                let primaryField = this.tableUtil.getPrimaryField(this.table)
                return primaryField.id === field.id
            },
            isNumeric(field) {
                return new FieldUtil(field).isNumeric()
            },
            detailsRoute(documentId) {
                if (this.isChildList) {

                    let routeParams = {
                        table_id: this.table.id,
                        record_id: documentId,
                        parentDocument: this.parentDocument,
                        parentTable: this.parentTable,
                        app_id: this.model.app.id
                    }

                    return {name: 'static-details', params: routeParams}
                }

                if (webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId, app_id: this.model.app.id}}
            },
            onDeleteClick(document) {
                this.$emit('documentDeleteClick', document)
            },
            attachments(field) {
                return this.document[field.index] ? this.document[field.index] : []
            }
        }
    }
</script>

<style>

</style>
